import { create } from 'zustand';

const useZoneStore = create((set) => ({
  zone: {},

  setZone: (newZone) => set({ zone: newZone }),

  clearZone: () => set({ zone: {} }),
}));

export default useZoneStore;
